import { useGetUserQuery } from 'shared/api/auth/requests'
import { LocalStorageKey } from 'shared/constants/localStorage'
import { useUserContext } from 'shared/hooks/useUserContext'
import { lsGetItem } from 'shared/utils/local-storage'

export const useCommonProjectManagementData = () => {
  const { user } = useUserContext()

  const { data: userData } = useGetUserQuery(
    {
      id: user?.id || -1
    },
    {
      enabled: typeof user?.id === 'number'
    }
  )
  const lsUser = lsGetItem(LocalStorageKey.USER)

  return {
    user: {
      ...lsUser,
      ...userData?.data
    }
  }
}
